import StarIcon from '../icons/StarIcon';
import styles from './StarRating.module.scss';

function StarRating({ rating }: { rating: number }) {
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 >= 0.5;

  return (
    <div className={styles.planStarRating}>
      <p className={styles.title}>Medicare Star Rating:</p>
      <div className={styles.planStarsContainer}>
        {[...Array(5)].map((_, index) => (
          <div key={index} aria-hidden="true">
            {index < fullStars ? (
              <StarIcon />
            ) : index === fullStars && hasHalfStar ? (
              <StarIcon starType="half" />
            ) : (
              <StarIcon starType="empty" />
            )}
          </div>
        ))}
        <p>{rating} / 5</p>
      </div>
    </div>
  );
}

export default StarRating;
